import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

class Example extends Component {
  state = {
    show: false,
  };

  onClose = () =>
    this.setState({
      show: false,
    });

  onShow = () =>
    this.setState({
      show: true,
    });

  render() {
    return (
      <>
        <p onClick={this.onShow}>Open Modal</p>

        <Modal show={this.state.show} onHide={this.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Modal heading</Modal.Title>
          </Modal.Header>
          <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.onClose}>
              Close
            </Button>
            <Button variant='primary' onClick={this.onClose}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

function NotFoundPage() {
  return (
    <div>
      Not Found Page
      <Example />
    </div>
  );
}

export default NotFoundPage;
